export const SELECTOR_SEARCH_QUERY = (state) => state.search.query;
export const SELECTOR_SEARCH_PAGE = (state) => state.search.page;
export const SELECTOR_SEARCH_FILTERS = (state) => state.search.searchFilters;
